import type { CargoCategory } from '../freightlancer.model';

export enum CargoCategoryDetailPages {
  BOAT_TRANSPORT = 'boat-transport',
  BULK_TIPPER_TRANSPORT = 'bulk-tipper-transport',
  CAR_TRANSPORT = 'car-transport',
  CONTAINER_TRANSPORT = 'container-transport',
  FURNITURE_REMOVAL = 'furniture-removal',
  GENERAL_FREIGHT = 'general-freight',
  GRAIN_TRANSPORT = 'grain-transport',
  HAY_TRANSPORT = 'hay-transport',
  HEAVY_HAULAGE = 'heavy-haulage',
  LIQUID_TANKER = 'liquid-tanker',
  LIVESTOCK_TRANSPORT = 'livestock-transport',
  MACHINERY_TRANSPORT = 'machinery-transport',
  PALLETISED_FREIGHT = 'palletised-freight',
  PORTABLE_BUILDINGS = 'portable-buildings',
  TRAILER_TRANSPORT = 'trailer-transport',
  TRUCK_TRANSPORT = 'truck-transport',
  TRACTOR_TRANSPORT = 'tractor-transport',
  GENERATOR_TRANSPORT = 'generator-transport',
  PUMP_TRANSPORT = 'pump-transport',
  CRANE_TRANSPORT = 'crane-transport',
  CONSTRUCTION_EQUIPMENT = 'construction-equipment',
  SKID_TRANSPORT = 'skid-transport',
  CRATE_TRANSPORT = 'crate-transport',
  BULK_HAULAGE_CONTRACTS = 'bulk-haulage-contracts',
  HEAVY_EQUIPMENT_HAULING = 'heavy-equipment-hauling',
  LOADER_TRANSPORT = 'loader-transport',
  SIDE_LOADER_TRANSPORT = 'side-loader-transport',
  HEAVY_HAULERS = 'heavy-haulers',
  LOW_LOADER_TRANSPORT = 'low-loader-transport',
  HEAVY_MACHINERY_TRANSPORT = 'heavy-machinery-transport',
  CATTLE_TRANSPORT = 'cattle-transport',
  SHEEP_TRANSPORT = 'sheep-transport',
  PALLET_FREIGHT_QUOTES = 'pallet-freight-quotes',
  SHIP_PALLETS = 'ship-pallets',
  DONGA_TRANSPORT = 'donga-transport',
  DEMOUNTABLE_TRANSPORT = 'demountable-transport',
  CAR_TRANSPORT_TRAILERS = 'car-transport-trailers',
  REFRIGERATED_FREIGHT_RATES = 'refrigerated-freight-rates',
  CHILLED_TRANSPORT = 'chilled-transport',
  TRACTOR_HAULAGE = 'tractor-haulage',
  CAMPER_TRAILER_TRANSPORT = 'camper-trailer-transport',
  ZERO_TURN_MOWER_TRANSPORT = 'zero-turn-mower-transport',
  EXCAVATOR_TRANSPORT = 'excavator-transport',
  DOZER_TRANSPORT = 'dozer-transport',
  BACKHOE_TRANSPORT = 'backhoe-transport',
  BOBCAT_TRANSPORT = 'bobcat-transport',
  SKID_STEER_TRANSPORT = 'skid-steer-transport',
  DUMP_TRUCK_TRANSPORT = 'dump-truck-transport',
  AG_EQUIPMENT_TRANSPORT = 'ag-equipment-transport',
  TAUTLINER_TRANSPORT = 'tautliner-transport',
  FIREWOOD_TRANSPORT = 'firewood-transport',
  CONCRETE_TRANSPORT = 'concrete-transport',
  ROLLER_TRANSPORT = 'roller-transport',
  ENGINE_TRANSPORT = 'engine-transport',
  WATER_TANK_TRANSPORT = 'water-tank-transport',
  FREIGHTLINER_TRANSPORT = 'freightliner-transport',
  FUEL_TANK_TRANSPORT = 'fuel-tank-transport',
  STEEL_TRANSPORT = 'steel-transport',
  GENIE_TRANSPORT = 'genie-transport',
  GO_KART_TRANSPORT = 'go-kart-transport',
  GOLF_CART_TRANSPORT = 'golf-cart-transport',
  HARLEY_DAVIDSON_TRANSPORT = 'harley-davidson-transport',
  TIMBER_TRANSPORT = 'timber-transport',
  JET_SKI_TRANSPORT = 'jet-ski-transport',
  JOHN_DEERE_TRANSPORT = 'john-deere-transport',
  KANGA_TRANSPORT = 'kanga-transport',
  KENWORTH_TRANSPORT = 'kenworth-transport',
  LIGHT_TRUCK_TRANSPORT = 'light-truck-transport',
  PRIME_MOVER_TRANSPORT = 'prime-mover-transport',
  QUAD_BIKE_TRANSPORT = 'quad-bike-transport',
  SCISSOR_LIFT_TRANSPORT = 'scissor-lift-transport',
  SITE_SHED_TRANSPORT = 'side-shed-transport',
  SOLAR_PANEL_TRANSPORT = 'solar-panel-transport',
  TELEHANDLER_TRANSPORT = 'telehandler-transport',
  INTERSTATE_BOAT_TRANSPORT = 'interstate-boat-transport',
  BOAT_WITH_TRAILER = 'boat-with-trailer',
  FREIGHT_CONTRACT_TENDER = 'freight-contract-tender',
  GENERAL_SMALL = 'genera-small',
  DANGEROUS_GOODS = 'dangerous-goods',
  EARTHMOVING_EQUIPMENT = 'earthmoving-equipment',
  PIPE = 'pipe',
  MACHINERY_MOBILE = 'machinery-mobile',
  MACHINERY_STATIONARY = 'machinery-stationary',
  PALLET_SINGLE = 'pallet-single',
  TRAILER_CARAVAN_CAMPER = 'trailer-caravan-camper',
  TRAILER_TOWED_BY_CAR = 'trailer-towed-by-car',
  TRAILER_TOWING = 'trailer-towing',
  TRAILER_TO_BE_CARRIED = 'trailer-to-be-carried',
  FARM_MACHINERY_TRANSPORT = 'farm-machinery-transport',
  IBC_TRANSPORT = 'ibc-transport',
}

export const CATEGORY_LIST: readonly CargoCategory[] = [
  {
    name: 'Boat Transport',
    link: CargoCategoryDetailPages.BOAT_TRANSPORT,
  },
  {
    name: 'Bulk Tipper Transport',
    link: CargoCategoryDetailPages.BULK_TIPPER_TRANSPORT,
  },
  {
    name: 'Car Transport',
    link: CargoCategoryDetailPages.CAR_TRANSPORT,
  },
  {
    name: 'Container Transport',
    link: CargoCategoryDetailPages.CONTAINER_TRANSPORT,
  },
  {
    name: 'Furniture Removal',
    link: CargoCategoryDetailPages.FURNITURE_REMOVAL,
  },
  {
    name: 'General Freight',
    link: CargoCategoryDetailPages.GENERAL_FREIGHT,
  },
  {
    name: 'Grain Transport',
    link: CargoCategoryDetailPages.GRAIN_TRANSPORT,
  },
  {
    name: 'Hay Transport',
    link: CargoCategoryDetailPages.HAY_TRANSPORT,
  },
  {
    name: 'Heavy Haulage',
    link: CargoCategoryDetailPages.HEAVY_HAULAGE,
  },
  {
    name: 'Liquid Tanker Transport',
    link: CargoCategoryDetailPages.LIQUID_TANKER,
  },
  {
    name: 'Livestock Transport',
    link: CargoCategoryDetailPages.LIVESTOCK_TRANSPORT,
  },
  {
    name: 'Machinery Transport',
    link: CargoCategoryDetailPages.MACHINERY_TRANSPORT,
  },
  {
    name: 'Palletised Freight',
    link: CargoCategoryDetailPages.PALLETISED_FREIGHT,
  },
  {
    name: 'Portable Buildings',
    link: CargoCategoryDetailPages.PORTABLE_BUILDINGS,
  },
  {
    name: 'Trailer Transport',
    link: CargoCategoryDetailPages.TRAILER_TRANSPORT,
  },
  {
    name: 'Truck Transport',
    link: CargoCategoryDetailPages.TRUCK_TRANSPORT,
  },
  {
    name: 'Tractor Transport',
    link: CargoCategoryDetailPages.TRACTOR_TRANSPORT,
  },
  {
    name: 'Generator Transport',
    link: CargoCategoryDetailPages.GENERATOR_TRANSPORT,
  },
  {
    name: 'Pump Transport',
    link: CargoCategoryDetailPages.PUMP_TRANSPORT,
  },
  {
    name: 'Crane Transport',
    link: CargoCategoryDetailPages.CRANE_TRANSPORT,
  },
  {
    name: 'Construction Equipment',
    link: CargoCategoryDetailPages.CONSTRUCTION_EQUIPMENT,
  },
  {
    name: 'Skid Transport',
    link: CargoCategoryDetailPages.SKID_TRANSPORT,
  },
  {
    name: 'Bulk Haulage Contracts',
    link: CargoCategoryDetailPages.BULK_HAULAGE_CONTRACTS,
  },
  {
    name: 'Crate Transport',
    link: CargoCategoryDetailPages.CRATE_TRANSPORT,
  },
];
